var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"loading":_vm.loading},on:{"click":_vm.loadManual}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"green darken-4"}},[_vm._v("mdi-microsoft-excel")]),_vm._v(" Выгрузить справочник ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }